import React from 'react'
import { Theme, useMediaQuery } from '@mui/material'
import {
  ContentBox,
  FixedPictureWrapper,
  LayoutWrapper,
  LeftImgPicture,
  LeftPictureGrid,
  LogoPicture,
  LogoPictureWrapper,
} from './AppView.styled'
import Image from 'next/image'

import seasonLifeImageIpad from '@/images/left-ipad.jpg'
import seasonLifeImageDesktop from '@/images/left.jpg'
import seasonLifeImageHR from '@/images/left-high-resolution.jpg'
import logoShort from '@/images/logo-short-black.png'
import logo from '@/images/logo-black.png'

interface Props {
  children: React.ReactNode
}

const AppView: React.FC<Props> = ({ children }) => {
  const isLarge = useMediaQuery<Theme>((theme) => theme.breakpoints.up('sm'))

  return (
    <LayoutWrapper>
      {isLarge && (
        <LeftPictureGrid container>
          <FixedPictureWrapper>
            <LeftImgPicture>
              <source media="(max-width: 1279px)" srcSet={seasonLifeImageIpad.src} />
              <source media="(max-width: 1919px)" srcSet={seasonLifeImageDesktop.src} />
              <source media="(min-width: 1920px)" srcSet={seasonLifeImageHR.src} />
              <Image fill priority src={seasonLifeImageDesktop.src} alt="Charleston Wrap" />
            </LeftImgPicture>
          </FixedPictureWrapper>
          <FixedPictureWrapper>
            <LogoPictureWrapper>
              <LogoPicture>
                <source media="(max-width: 1279px)" srcSet={logoShort.src} />
                <source media="(max-width: 1400px)" srcSet={logo.src} />
                <Image fill src={logo.src} alt="Charleston Wrap Logo" />
              </LogoPicture>
            </LogoPictureWrapper>
          </FixedPictureWrapper>
        </LeftPictureGrid>
      )}
      <ContentBox>{children}</ContentBox>
    </LayoutWrapper>
  )
}

export default AppView
